import React from 'react';
import {Redirect, Route, Switch, withRouter} from 'react-router-dom';

import http from 'api/http';
import { boatAPI } from 'api/requests';

import {
  getBoatSteps,
  STEP_ID,
  BOAT_APPLICATION_ALLOWED_UNCONFIRMED_TRANSITIONS,
  BOAT,
  CATAMARAN,
  SAILBOAT, PONTOON, JON_BOAT, PWC, INFLATABLE, CANOE_KAYAK, OUTBOARD
} from 'constants/boatApplication';
import { ACTION } from 'constants/index';

import BoatTypeSelectScene from './BoatTypeSelect';
import EngineTypeSelectScene from './EngineTypeSelect';
import BoatSpecifications from './BoatSpecifications';
import CubicCapacityScene from './CubicCapacityScene';
import PersonPowerCapacity from './PersonPowerCapacity';
import PowerCapacity from './PowerCapacity';
import FloatationCapacity from './FloatationCapacity';
import AddComponents from './AddComponents';
import FinalReview from './FinalReview';
import LoadAdditionalDocuments from './LoadAdditionalDocuments';

/**
 * Components
 */
import Header from './Header';
import StepNavBar from './StepNavBar';
import NotificationManager from 'dom-managers/notification';
import Button, { buttonColor, buttonType } from 'Components/Button';
import Modal from 'Components/Modal';
import TransitionBlockerModal from 'Components/TransitionBlockerModal';
import { bindActionCreators } from 'redux';
import * as boatActions from '../../../../store/actions/boat';
import connect from 'react-redux/es/connect/connect';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  selectBoatType: bindActionCreators(boatActions.selectBoatType, dispatch),
  selectEngineType: bindActionCreators(boatActions.selectEngineType, dispatch),
  updateBoatDetails: bindActionCreators(boatActions.updateBoatDetails, dispatch)
});

@withRouter
@connect(mapStateToProps, mapDispatchToProps)
export default class BoatManufacturer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      stepsValidation: {[STEP_ID.FINAL_REVIEW]: true, [STEP_ID.LOAD_DOCUMENTS]: true},
      stepIsChanged: true,
      isModalOpen: false,
      unsavedDataPresents: false,
    };

    this.modalBody = '';
    this.modalConfirmAction = {};
  }

  componentDidMount() {
    let {stepsValidation} = this.state;
    const {user, boat, match} = this.props;
    const {applicationId, step} = match.params;
    const storedStepsState = user.getStoredState('boatStepsState');
    let stepIsChanged = false;

    if (storedStepsState.id && +storedStepsState.id === +applicationId) {
      stepsValidation = storedStepsState.steps;
      stepIsChanged = !stepsValidation[step];

    } else {
      if (boat.status === 'APPROVED') {
        getBoatSteps(boat.boatType, boat.engineType).forEach(boatStep => {
          stepsValidation[boatStep.id] = true;
        });

      } else {
        if (boat.boatType) stepsValidation[STEP_ID.BOAT_TYPE] = true;
        if (boat.engineType) stepsValidation[STEP_ID.ENGINE_TYPE] = true;
        stepIsChanged = true;
      }
    }

    stepsValidation = this.getActiveStepsValidation(stepsValidation, boat);
    this.setState({stepsValidation, stepIsChanged}, () => {user.saveState('boatStepsState', {id:applicationId, steps:stepsValidation})});
  }

  componentDidUpdate(previousProps) {
    const {boat, user} = this.props;
    if (boat.boatType !== previousProps.boat.boatType || boat.engineType !== previousProps.boat.engineType) {
      const stepsValidation = this.getActiveStepsValidation(this.state.stepsValidation, boat);
      this.setState({stepsValidation}, () => {
        user.saveState('boatStepsState', {id:boat.id, steps:stepsValidation});
      });
    }
  }

  getActiveStepsValidation = (stepsValidation, boat) => {
    const activeStepIds = getBoatSteps(boat.boatType, boat.engineType).map(step => step.id);
    return Object.keys(stepsValidation).reduce((activeStepsValidation, stepId) => {
      if (activeStepIds.includes(stepId)) activeStepsValidation[stepId] = stepsValidation[stepId];
      return activeStepsValidation;
    }, {});
  };

  componentWillUnmount() {
    let {stepsValidation} = this.state;
    const {user, boat} = this.props;

    user.saveState('boatStepsState', {id:boat.id, steps:stepsValidation})
  }

  goToStep = (nextStepPointer, isStepValid) => {
    const {stepIsChanged} = this.state;
    const {user, boat, match} = this.props;
    const {step} = match.params;
    const steps = getBoatSteps(boat.boatType, boat.engineType);

    if (nextStepPointer === 'next') {
      const currentStepIndex = steps.findIndex(st => st.id === step);
      nextStepPointer = steps[currentStepIndex + 1].id;
    } else if (nextStepPointer === 'prev') {
      const currentStepIndex = steps.findIndex(st => st.id === step);
      nextStepPointer = steps[currentStepIndex - 1].id;
    }

    if (isStepValid && stepIsChanged && isFinite(boat.id)) {
      NotificationManager.autosave();
    }

    this.setState(prevState => ({
      stepsValidation: {...prevState.stepsValidation, [step]: isStepValid},
      stepIsChanged: (!prevState.stepsValidation[nextStepPointer]),
      unsavedDataPresents: !isStepValid ||
        !isFinite(boat.id) ||
        !!Object.keys(prevState.stepsValidation).find(stepId => {
          return (prevState.stepsValidation[stepId] === false && stepId !== step);
        })
    }),
    () => {
      user.saveState('boatStepsState', {id:boat.id, steps:this.state.stepsValidation});
      user.goToApplicationStep(boat.id, nextStepPointer);
    }
    );
  };


  markStepAsRedacted = () => {
    const {boat, match} = this.props;
    const {step} = match.params;
    const {stepsValidation} = this.state;
    const steps = getBoatSteps(boat.boatType, boat.engineType);

    const stepIndex = steps.findIndex(st => st.id === step);
    steps.forEach((otherStep, index) => {
      if (index > stepIndex && stepsValidation[otherStep.id]) delete stepsValidation[otherStep.id];
    });
    this.setState({stepsValidation, stepIsChanged: true, unsavedDataPresents: true});
  };

  markCurrentStepAsSaved = () => {
    const {step} = this.props.match.params;
    const {stepsValidation} = this.state;

    stepsValidation[step] = true;
    this.setState({stepsValidation, stepIsChanged: false, unsavedDataPresents: false});
  };

  handleBoatSubmit = () => {
    const {stepsValidation} = this.state;
    const {user, boat} = this.props;
    let allStepsValid = true;

    getBoatSteps(boat.boatType, boat.engineType).forEach(step => {
      if (!stepsValidation[step.id] && step.id !== STEP_ID.FINAL_REVIEW) {
        allStepsValid = false;
        stepsValidation[step.id] = false;
      }
    });

    if (allStepsValid) {
      http.put(boatAPI.submit(boat.id))
        .then(() => {
          this.setState({stepIsChanged: false, unsavedDataPresents: false}, () => {
            NotificationManager.success('note', 'Your application was submitted successfully.');
            user.goToList(false, {
              elements: 'default',
              rowsCount: 'default',
              activePage: 'default',
              sortedBy: 'id',
              sortOrder: -1,
              filter: {
                status: 'APPROVED',
                boatType: boat.boatType,
                year: boat.boatSpecifications.year
              }
            });
          });
        });
    } else {
      NotificationManager.error(1, 'Not all steps a filled', 'Please fill all previous steps to submit boat.');
      this.setState({stepsValidation}, () => {
        user.saveState('boatStepsState', {id:boat.id, steps:stepsValidation});
      });
    }
  };

  handleDeleteDraft = () => {
    const {boat, user} = this.props;

    if (isFinite(boat.id)) {
      this.modalConfirmAction = () => {
        this.setState({isModalOpen: false, unsavedDataPresents: false},
          () => {
            http.delete(boatAPI.details(boat.id))
              .then(() => {
                user.goToList();
                NotificationManager.success(1, 'Draft application was deleted successfully.');
              });
          });
      };
    } else {
      this.modalConfirmAction = () => {
        this.setState({isModalOpen: false, unsavedDataPresents: false},
          () => {
            NotificationManager.success(1, 'Draft application was deleted successfully.');
            user.goToList();
          });
      };
    }

    this.modalBody = 'Are you sure you want to Delete this draft application?';
    this.setState({isModalOpen: true});
  };

  closeModal = () => {
    this.setState({isModalOpen: false});
  };

  maxLengthIs26 = () => {
    const {boatType} = this.props.boat;
    if (boatType === BOAT) return true;
    if (boatType === CATAMARAN) return true;
    if (boatType === SAILBOAT) return true;
    if (boatType === PONTOON) return true;
    if (boatType === JON_BOAT) return true;
    if (boatType === PWC) return true;
    if (boatType === INFLATABLE) return true;
    if (boatType === CANOE_KAYAK) return true;
    return false;
  };

  getNavBar = (handleMoveToNextStep, handleMoveToArbitraryStep) => {
    const {stepsValidation} = this.state;
    const {boat, match} = this.props;
    const {step} = match.params;

    return (
      <StepNavBar
        step={step}
        stepsList={getBoatSteps(boat.boatType, boat.engineType)}
        stepsValidation={stepsValidation}
        handleMoveToNextStep={handleMoveToNextStep}
        handleMoveToArbitraryStep={handleMoveToArbitraryStep}
      />
    );
  };

  getHeader = handleSaveStepAsync => {
    const {boat, user, match} = this.props;
    const {step} = match.params;

    switch (step) {
      case 'boat_type':
        return <Header
          boat={boat}
          text='Select Boat Type'
          user={user}
        />;

      case 'engine_type':
        return <Header
          boat={boat}
          text='Select Engine Type'
          user={user}
        />;

      default:
        return <Header
          boat={boat}
          handleSaveStep={handleSaveStepAsync}
          handleDeleteDraft={this.handleDeleteDraft}
          markCurrentStepAsSaved={this.markCurrentStepAsSaved}
          stepIsChanged={this.state.stepIsChanged}
          user={user}
        />;
    }
  };

  initNewBoat = () => {
    const {user, clearBoatDetails} = this.props;

    clearBoatDetails();
    localStorage.removeItem('boatStepsState');
    user.replaceLocation(`/${user.getManufacturerCode()}/boat/application/New/${STEP_ID.BOAT_TYPE}`);

    return(
      null
    )
  };

  render() {
    const {user, boat, selectBoatType, selectEngineType, updateBoatDetails, match} = this.props;
    const {stepIsChanged, isModalOpen, unsavedDataPresents} = this.state;
    const basePath = match.path.slice(0, -6);

    if (user.isInspector()) user.goToList();

    return (
      <React.Fragment>
        <section className='scene__scene-wrapper'>
          <section
            className={`scene__content-wrapper
          ${document.documentMode || /Edge/.test(navigator.userAgent) ? 'display-block-on-print' : ''}`}
          >
            <Switch>
              <Route exact path={`${basePath}/InitNewBoat`} render={this.initNewBoat} />

              <Route
                exact
                path={`${basePath}/${STEP_ID.BOAT_TYPE}`}
                render={() => (
                  <BoatTypeSelectScene
                    getNavBar={this.getNavBar}
                    getHeader={this.getHeader}
                    boat={boat}
                    selectBoatType={selectBoatType}
                    goToStep={this.goToStep}
                    markStepAsRedacted={this.markStepAsRedacted}
                    stepIsChanged={stepIsChanged}
                  />
                )}
              />

              <Route
                exact
                path={`${basePath}/${STEP_ID.ENGINE_TYPE}`}
                render={() => (
                  <EngineTypeSelectScene
                    getNavBar={this.getNavBar}
                    getHeader={this.getHeader}
                    boat={boat}
                    selectEngineType={selectEngineType}
                    goToStep={this.goToStep}
                    markStepAsRedacted={this.markStepAsRedacted}
                    stepIsChanged={stepIsChanged}
                  />
                )}
              />

              <Route
                exact
                path={`${basePath}/${STEP_ID.BOAT_SPECIFICATIONS}`}
                render={() => (
                  <BoatSpecifications
                    user={user}
                    boat={boat}
                    getNavBar={this.getNavBar}
                    getHeader={this.getHeader}
                    goToStep={this.goToStep}
                    markStepAsRedacted={this.markStepAsRedacted}
                    maxLengthIs26={this.maxLengthIs26}
                    updateBoatDetails={updateBoatDetails}
                    stepIsChanged={stepIsChanged}
                  />
                )}
              />

              <Route
                exact
                path={`${basePath}/${STEP_ID.ADD_COMPONENTS}`}
                render={() => (
                  <AddComponents
                    getNavBar={this.getNavBar}
                    getHeader={this.getHeader}
                    user={user}
                    boat={boat}
                    goToStep={this.goToStep}
                    markStepAsRedacted={this.markStepAsRedacted}
                    updateBoatDetails={updateBoatDetails}
                    stepIsChanged={stepIsChanged}
                  />
                )}
              />

              <Route
                exact
                path={`${basePath}/${STEP_ID.CUBIC_CAPACITY}`}
                render={() => (
                  <CubicCapacityScene
                    user={user}
                    boat={boat}
                    getNavBar={this.getNavBar}
                    getHeader={this.getHeader}
                    goToStep={this.goToStep}
                    updateBoatDetails={updateBoatDetails}
                    markStepAsRedacted={this.markStepAsRedacted}
                    stepIsChanged={stepIsChanged}
                  />
                )}
              />

              <Route
                exact
                path={`${basePath}/${STEP_ID.WEIGHT_CAPACITY}`}
                render={() => (
                  <PersonPowerCapacity
                    user={user}
                    boat={boat}
                    getNavBar={this.getNavBar}
                    getHeader={this.getHeader}
                    goToStep={this.goToStep}
                    updateBoatDetails={updateBoatDetails}
                    markStepAsRedacted={this.markStepAsRedacted}
                    stepIsChanged={stepIsChanged}
                  />
                )}
              />

              <Route
                exact
                path={`${basePath}/${STEP_ID.POWER_CAPACITY}`}
                render={() => (
                  <PowerCapacity
                    user={user}
                    boat={boat}
                    getNavBar={this.getNavBar}
                    getHeader={this.getHeader}
                    goToStep={this.goToStep}
                    updateBoatDetails={updateBoatDetails}
                    markStepAsRedacted={this.markStepAsRedacted}
                    stepIsChanged={stepIsChanged}
                  />
                )}
              />

              <Route
                exact
                path={`${basePath}/${STEP_ID.FLOATATION_CAPACITY}`}
                render={() => boat.engineType === OUTBOARD ? (
                  <FloatationCapacity
                    user={user}
                    boat={boat}
                    getNavBar={this.getNavBar}
                    getHeader={this.getHeader}
                    goToStep={this.goToStep}
                    updateBoatDetails={updateBoatDetails}
                    markStepAsRedacted={this.markStepAsRedacted}
                    stepIsChanged={stepIsChanged}
                  />
                ) : <Redirect to={`${basePath}/${STEP_ID.LOAD_DOCUMENTS}`} />
                }
              />

              <Route
                exact
                path={`${basePath}/${STEP_ID.LOAD_DOCUMENTS}`}
                render={() => (
                  <LoadAdditionalDocuments
                    boat={boat}
                    getNavBar={this.getNavBar}
                    getHeader={this.getHeader}
                    goToStep={this.goToStep}
                    handleDeleteDraft={this.handleDeleteDraft}
                    stepIsChanged={stepIsChanged}
                    markStepAsRedacted={this.markStepAsRedacted}
                    {...this.props}
                  />
                )}
              />

              <Route
                exact
                path={`${basePath}/${STEP_ID.FINAL_REVIEW}`}
                render={() => (
                  <FinalReview
                    getNavBar={this.getNavBar}
                    actionsList={boat.status === 'DRAFT' ? [ACTION.DELETE] : []}
                    getHeader={this.getHeader}
                    handleBoatSubmit={this.handleBoatSubmit}
                    goToStep={this.goToStep}
                    markStepAsRedacted={this.markStepAsRedacted}
                    handleDeleteDraft={this.handleDeleteDraft}
                    stepIsChanged={stepIsChanged}
                    {...this.props}
                  />
                )}
              />
            </Switch>
          </section>
        </section>

        <Modal isOpen={isModalOpen}>
          <header className='ect-modal-header'>Confirmation</header>
          <div className='ect-modal-body'>{this.modalBody}</div>
          <footer className='ect-modal-footer'>
            <Button
              label='No'
              type={buttonType.secondary}
              color={buttonColor.gray}
              buttonClassName='_height_40 _width_160'
              onClick={this.closeModal}
            />
            <Button label='Yes' buttonClassName='_height_40 _width_160' onClick={this.modalConfirmAction} />
          </footer>
        </Modal>

        <TransitionBlockerModal
          blockTransitions={unsavedDataPresents}
          transitionWhitelist={BOAT_APPLICATION_ALLOWED_UNCONFIRMED_TRANSITIONS}
        >
          <header className='ect-modal-header'>Confirmation</header>
          <div className='ect-modal-body'>
            You have unsaved data. Are you sure you want to exit application without saving?
          </div>
        </TransitionBlockerModal>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/index.jsx